import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import NirovisionConnectionSettings from '../../components/Nirovision/NirovisionConnectionSettings';

const NirovisionConnectionPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const navigate = useNavigate();
    const onClickGoBack = () => {
        navigate(-1);
    };
    const theme = useTheme();

    return (
        <Grid
            sx={{
                width: '100%',
                // height: isMobile ? '100%' : '80%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <NirovisionConnectionSettings />
            <Grid sx={{ height: isMobile ? '5%' : '5%' }}>
                {' '}
                <CustomButton
                    onClick={onClickGoBack}
                    color='primary'
                    sx={{
                        marginLeft: !isMobile ? '-8px' : '-18px',
                        '&:hover': {
                            cursor: 'pointer',
                            color: theme.palette.textAccent.main,
                            backgroundColor: 'transparent',
                            background: 'none',
                        },
                    }}
                >
                    <ArrowBackIcon />{' '}
                    {isMobile ? null : (
                        <Typography
                            sx={{
                                fontSize: '12px',
                                paddingLeft: '5px',
                            }}
                        >
                            Back to Admin Centre
                        </Typography>
                    )}
                </CustomButton>
            </Grid>
        </Grid>
    );
};

export default NirovisionConnectionPage;
